import { render, staticRenderFns } from "./DisplayCommunicationNoti.vue?vue&type=template&id=46037524&scoped=true&"
import script from "./DisplayCommunicationNoti.vue?vue&type=script&lang=js&"
export * from "./DisplayCommunicationNoti.vue?vue&type=script&lang=js&"
import style0 from "./DisplayCommunicationNoti.vue?vue&type=style&index=0&id=46037524&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46037524",
  null
  
)

export default component.exports